import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=300edd1f&scoped=true"
import script from "./UserMessage.vue?vue&type=script&lang=js"
export * from "./UserMessage.vue?vue&type=script&lang=js"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=300edd1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300edd1f",
  null
  
)

export default component.exports